<template>
    <!--    <el-table v-bind="$attrs" v-on="$listeners" v-adaptive="{bottomOffset: 430}">-->
    <el-table ref="table"
              :key="randomKey"
              v-bind="$attrs"
              :data="dataList"
              :showSummary="true"
              :summary-method="getSummaries"
              v-on="$listeners">
        <template slot="append">
            <slot name="append"></slot>
        </template>

        <template v-for="item in columns">
            <el-table-column v-if="['index', 'selection'].includes(item.type)"
                             :label="item.title"
                             :width="item.width"
                             :key="item.type"
                             :type="item.type"
                             :fixed="item.fixed || false">
            </el-table-column>

            <el-table-column v-else-if="['choose'].includes(item.type)"
                             :label="item.title"
                             :width="item.width"
                             :key="item.key"
                             :type="item.type"
                             :fixed="item.fixed || false">
                <template slot-scope="scope">
                    <!-- 编辑时 -->
                    <template v-if="item.edit && scope.row._edit">
                        <EditItem :ref="'chechItem-' + scope.$index"
                                  v-model="scope.row[item.key]"
                                  :rowIndex="scope.$index"
                                  :formData="scope.row"
                                  :conf="conf"
                                  :options="item"
                                  @refreshTable="refreshTable">
                        </EditItem>
                    </template>
                    <!-- 预览时 -->
                    <slot v-else :name="item.key" :row="scope.row" :$index="scope.$index">
                        <el-tag effect="dark" size="medium" style="text-align:center;margin-right: 5px">
                            {{ scope.row[item.key] }}
                        </el-tag>
                    </slot>
                </template>
            </el-table-column>

            <el-table-column v-else-if="['file'].includes(item.type)"
                             :label="item.title"
                             :width="item.width"
                             :key="item.type"
                             :type="item.type"
                             :fixed="item.fixed || false">
                <template slot-scope="scope">
                    <!-- 编辑时 -->
                    <template v-if="item.edit && scope.row._edit">
                        <EditItem v-model="scope.row[item.key]"
                                  :rowIndex="scope.$index"
                                  :conf="conf"
                                  :options="item"
                                  :ref="'chechItem-' + scope.$index">
                        </EditItem>
                    </template>
                    <!-- 预览时 -->
                    <slot v-else :name="item.key" :row="scope.row" :$index="scope.$index">
                        {{scope.row[item.key]?scope.row[item.key].length:0}}
                    </slot>
                </template>
            </el-table-column>

            <el-table-column v-else-if="['switch'].includes(item.type)"
                             :label="item.title"
                             :width="item.width"
                             :key="item.type"
                             :type="item.type"
                             :fixed="item.fixed || false">
                <template slot-scope="scope">
                    <!-- 编辑时 -->
                    <template v-if="item.edit && scope.row._edit">
                        <EditItem v-model="scope.row[item.key]"
                                  :options="item"
                                  :rowIndex="scope.$index"
                                  :conf="conf"
                                  :ref="'chechItem-' + scope.$index">
                        </EditItem>
                    </template>
                    <!-- 预览时 -->
                    <slot v-else :name="item.key" :row="scope.row" :$index="scope.$index">
                        <el-switch v-model="scope.row[item.key]" disabled>
                        </el-switch>
                    </slot>
                </template>
            </el-table-column>

            <el-table-column v-else-if="item.visible === undefined ? true : item.visible"
                             :label="item.title"
                             :key="item.key"
                             :prop="item.key"
                             :width="item.width === undefined ? 100 : item.width"
                             :min-width="item.minWidth"
                             :fixed="item.fixed || false">
                <template slot-scope="scope">
                    <!-- 编辑时 -->
                    <template v-if="item.edit && scope.row._edit">
                        <EditItem v-model="scope.row[item.key]"
                                  :options="item"
                                  :rowIndex="scope.$index"
                                  :conf="conf"
                                  :data="data"
                                  :formData="scope.row"
                                  @input="setInput(scope.row,item)"
                                  @copyInput="copyInput"
                                  :ref="'chechItem-' + scope.$index">
                        </EditItem>
                    </template>
                    <!-- 预览时 -->
                    <slot v-else :name="item.key" :row="scope.row" :$index="scope.$index">
                        <i v-if="item.type === 'icon'" :class="scope.row[item.key]"></i>
                        <span v-else-if="item.type === 'select'">
                          {{ scope.row[item.key] || selectFilter(item.options || []) }}
                        </span>
                        <span v-else>{{ scope.row[item.key] }}</span>
                    </slot>
                </template>
            </el-table-column>
        </template>

        <el-table-column label="操作" v-if="!conf.disabled && actionsWidth>0"
                         :width="actionsWidth" :fixed="actionsFixed">
            <template slot="header">
                <slot name="header"></slot>
            </template>

            <template slot-scope="scope">
                <slot name="column-actions"
                      :row="scope.row"
                      :$index="scope.$index">
                </slot>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>

    import EditItem from "./EditItem.vue";
    import adaptive from '@/components/element/el-table/index'

    export default {
        /**
         * 事件
         * @delItem 点击删除时执行 参数：当前row
         * @submitRow 点击保存并通过验证 参数：当前 row,是否通过 valid
         */
        name: "ElTableEdit",
        components: {EditItem},
        directives: {adaptive},
        props: {
            form:{},
            data: {
                type: Array,
                default: () => [],
            },
            conf: {
                type: Object,
                required: true
            },
            // 列配置
            columns: {
                type: Array,
                default: () => [],
            },
            // 操作栏宽度
            actionsWidth: {
                type: Number,
                default: 250,
            },
            actionsFixed: {
                type: [Boolean, String],
                default: false,
            },
            editButText: {
                type: String,
                default: "编辑",
            },
            submitButText: {
                type: String,
                default: "保存",
            },
            cancelButText: {
                type: String,
                default: "取消",
            },
            precisionNum: {
                type: Number,
                default: 2,
            },
            precisionPrice: {
                type: Number,
                default: 2,
            },
            precisionTotal: {
                type: Number,
                default: 2,
            },
        },
        watch: {
            data: {
                handler(val) {
                    this.dataList = val;
                },
                deep: true,
            }
        },
        data() {
            return {
                dataList: [],
                randomKey: Math.random(),
            }
        },

        mounted() {
        },
        updated () {
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
        },

        methods: {
            setInput(rowData, options) {
                for(let i=0;i<this.dataList.length;i++){
                    let item = this.dataList[i];
                    if(item.id == rowData.id || item.randomId == rowData.randomId){
                        if (options.changeLink) {
                            if(options.key == "num"){
                                if (this.$pub.isNotEmpty(item.num)) {
                                    if(this.$pub.isNotEmpty(item.taxPrice) ) {
                                        item.taxTotal = this.$pub.getMultiplyData(item.taxPrice,item.num);
                                        if(this.$pub.isNotEmpty(item.taxRate)){
                                            item.price = this.$pub.getPrice(item.taxRate,item.taxPrice,this.precisionPrice);
                                            item.total = this.$pub.getMultiplyData(item.price,item.num,this.precisionTotal);
                                            item.tax = this.$pub.getTax(item.taxRate,item.total,this.precisionTotal);
                                        }
                                    } else if(this.$pub.isNotEmpty(item.price) ) {
                                        item.total = this.$pub.getMultiplyData(item.price,item.num);
                                        if(this.$pub.isNotEmpty(item.taxRate)) {
                                            item.taxPrice = this.$pub.getTaxPrice(item.taxRate, item.price, this.precisionPrice);
                                            item.taxTotal = this.$pub.getMultiplyData(item.taxPrice, item.num, this.precisionTotal);
                                            item.tax = this.$pub.getTax(item.taxRate, item.total, this.precisionTotal);

                                        }
                                    }

                                    if(this.$pub.isNotEmpty(item.costPrice)) {
                                        item.costTotal = this.$pub.getMultiplyData(item.num,item.costPrice,this.precisionTotal);
                                        //计算利润
                                        item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                                    }
                                    if(this.$pub.isNotEmpty(item.endCostPrice) ) {
                                        item.endCostTotal = this.$pub.getMultiplyData(item.num,item.endCostPrice,this.precisionTotal);
                                    }

                                }
                            }
                            if(options.key == "price"){
                                if (this.$pub.isNotEmpty(item.price)) {
                                    if(this.$pub.isNotEmpty(item.num) ) {
                                        item.total = this.$pub.getMultiplyData(item.price,item.num);
                                        if(this.$pub.isNotEmpty(item.taxRate)) {
                                            item.taxPrice = this.$pub.getTaxPrice(item.taxRate, item.price, this.precisionPrice);
                                            item.taxTotal = this.$pub.getMultiplyData(item.taxPrice, item.num, this.precisionTotal);
                                            item.tax = this.$pub.getTax(item.taxRate, item.total, this.precisionTotal);

                                            if(this.$pub.isNotEmpty(item.costPrice)) {
                                                item.costTotal = this.$pub.getMultiplyData(item.num,item.costPrice,this.precisionTotal);
                                                //计算利润
                                                item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                                            }
                                        }
                                    }
                                }
                            }
                            if(options.key == "taxRate" ){
                                if (this.$pub.isNotEmpty(item.taxRate)) {
                                    if(this.$pub.isNotEmpty(item.num) ) {
                                        if(this.$pub.isNotEmpty(item.price) ) {
                                            item.total = this.$pub.getMultiplyData(item.price, item.num);
                                            item.taxPrice = this.$pub.getTaxPrice(item.taxRate, item.price, this.precisionPrice);
                                            item.taxTotal = this.$pub.getMultiplyData(item.taxPrice, item.num, this.precisionTotal);
                                            item.tax = this.$pub.getTax(item.taxRate, item.total, this.precisionTotal);
                                        }else if(this.$pub.isNotEmpty(item.taxPrice) ) {
                                            item.taxTotal = this.$pub.getMultiplyData(item.taxPrice,item.num);
                                            item.price = this.$pub.getPrice(item.taxRate,item.taxPrice,this.precisionPrice);
                                            item.total = this.$pub.getMultiplyData(item.price,item.num,this.precisionTotal);
                                            item.tax = this.$pub.getTax(item.taxRate,item.total,this.precisionTotal);
                                        }

                                        if(this.$pub.isNotEmpty(item.costPrice)) {
                                            item.costTotal = this.$pub.getMultiplyData(item.num,item.costPrice,this.precisionTotal);
                                            //计算利润
                                            item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                                        }
                                    }
                                }
                            }
                            if(options.key == "taxPrice" ){
                                if (this.$pub.isNotEmpty(item.taxPrice)&& this.$pub.isNotEmpty(item.num)) {
                                    item.taxTotal = this.$pub.getMultiplyData(item.taxPrice,item.num);
                                    if(this.$pub.isNotEmpty(item.taxRate)){
                                        item.price = this.$pub.getPrice(item.taxRate,item.taxPrice,this.precisionPrice);
                                        item.total = this.$pub.getMultiplyData(item.price,item.num,this.precisionTotal);
                                        item.tax = this.$pub.getTax(item.taxRate,item.total,this.precisionTotal);
                                    }

                                    if(this.$pub.isNotEmpty(item.costPrice)) {
                                        item.costTotal = this.$pub.getMultiplyData(item.num,item.costPrice,this.precisionTotal);
                                        //计算利润
                                        item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                                    }
                                }
                            }
                            if(options.key == "costPrice" ){
                                if (this.$pub.isNotEmpty(item.num)) {
                                    if(this.$pub.isNotEmpty(item.costPrice)) {
                                        item.costTotal = this.$pub.getMultiplyData(item.num,item.costPrice,this.precisionTotal);
                                        //计算利润
                                        item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                                    }
                                }
                            }

                            if(options.key == "checkPrice" || options.key == "checkNum"){
                                if (this.$pub.isNotEmpty(item.checkPrice) && this.$pub.isNotEmpty(item.checkNum)){
                                    item.checkTotal = this.$pub.getMultiplyData(item.checkPrice,item.checkNum);

                                    if (this.$pub.isNotEmpty(item.billNum) && this.$pub.isNotEmpty(item.checkNum)) {
                                        item.lossNum =  this.$pub.getMinusData(item.billNum,item.checkNum);
                                    }
                                    if (this.$pub.isNotEmpty(item.billTotal) && this.$pub.isNotEmpty(item.checkTotal)) {
                                        item.lossTotal =  this.$pub.getMinusData(item.billTotal,item.checkTotal);
                                    }
                                }
                            }

                            if(options.key == "workingNum" ){
                                if (this.$pub.isNotEmpty(item.workingNum)) {
                                    if(this.$pub.isNotEmpty(item.workingPrice)) {
                                        item.workingTotal = this.$pub.getMultiplyData(item.workingNum,item.workingPrice,this.precisionTotal);
                                    }
                                }
                            }

                            if(options.key == "workingPrice" ){
                                if (this.$pub.isNotEmpty(item.workingPrice)) {
                                    if(this.$pub.isNotEmpty(item.workingNum)) {
                                        item.workingTotal = this.$pub.getMultiplyData(item.workingNum,item.workingPrice,this.precisionTotal);
                                    }
                                }
                            }
                        }
                    }
                }

                if(options.key==="payTotal"){
                    this.form.taxTotal = this.$pub.getPayTotal(this.dataList, this.precisionTotal);
                }else {
                    this.form.billTotal = this.$pub.getBillTotal(this.dataList, this.precisionTotal);
                    this.form.taxTotal = this.$pub.getTaxTotal(this.dataList, this.precisionTotal);
                }

                this.dataList = JSON.parse(JSON.stringify(this.dataList))

                for(let i=0;i<this.dataList.length;i++){
                    this.data[i] = this.dataList[i]
                }

            },
            copyInput(form) {
                this.formData=form;
                this.dataList.push(this.formData)
                for(let i=0;i<this.dataList.length;i++){
                    this.data[i] = this.dataList[i]
                }
            },
            getSelection() {
                return this.$refs.table.selection;
            },
            refreshTable() {
                this.randomKey = Math.random();
            },
            // 点击保存按钮时表单验证
            validateRow(type) {
                // this.refreshTable();
                const promiseList = [];
                this.dataList.forEach((data, index) => {

                    this.$refs["chechItem-" + index].forEach((item) => {
                        promiseList.push(item.validateRow());
                    });
                })
                return Promise.all(promiseList)
                    .then(() => {
                        this.$emit("submitRow",type);
                    })
                    .catch(() => {
                        // this.$emit("submitRow", row, false);
                    });
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                let num_total=0;
                let payTotal_total=0;
                let taxTotal_total=0;
                let billTotal_total=0;
                let costTotal_total=0;
                let profitTotal_total=0;
                for(let i=0;i<this.data.length;i++){
                    let item = this.data[i];

                    if(this.$pub.isNotEmpty(item.num) ) {
                        num_total=this.$pub.getPlusData(num_total,item.num,this.precisionTotal);
                    }
                    if(this.$pub.isNotEmpty(item.taxTotal)) {
                        taxTotal_total=this.$pub.getPlusData(taxTotal_total,item.taxTotal,this.precisionTotal);
                    }
                    if(this.$pub.isNotEmpty(item.total)) {
                        billTotal_total=this.$pub.getPlusData(billTotal_total,item.total,this.precisionTotal);
                    }
                    if(this.$pub.isNotEmpty(item.costTotal)) {
                        costTotal_total=this.$pub.getPlusData(costTotal_total,item.costTotal,this.precisionTotal);
                    }
                    if(this.$pub.isNotEmpty(item.profitTotal)) {
                        profitTotal_total=this.$pub.getPlusData(profitTotal_total,item.profitTotal,this.precisionTotal);
                    }
                    if(this.$pub.isNotEmpty(item.payTotal)) {
                        payTotal_total=this.$pub.getPlusData(profitTotal_total,item.payTotal,this.precisionTotal);
                    }
                }
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let field=column.property;
                    switch (field) {
                        case "num":
                            sums[index]=num_total;
                            break;
                        case "taxTotal":
                            sums[index]=taxTotal_total;
                            break;
                        case "total":
                            sums[index]=billTotal_total;
                            break;
                        case "costTotal":
                            sums[index]=costTotal_total;
                            break;
                        case "profitTotal":
                            sums[index]=profitTotal_total;
                            break;
                        case "payTotal":
                            sums[index]=payTotal_total;
                            break;
                    }
                });

                return sums;
            },
        },
        filters: {
            selectFilter(value, options) {
                return options.find((item) => item.value === value) || "";
            },
        },
    };
</script>
<style scoped>
    /deep/ .el-table .el-table__cell {
        padding: 8px;
    }

    /deep/ .el-table {
        overflow-y: auto !important;
    }

    /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }
    /deep/ .el-table__footer-wrapper td.el-table__cell {
        border-top: 1px solid #EBEEF5;
        white-space: nowrap;
        text-align:center;
    }
</style>